!<template>
  <div id="upload">
    <h1>Upload</h1>
    <v-form v-model="valid" @submit.prevent="onUpload()">
      <v-container>
        <v-row>
          <v-col class="mx-auto" cols="6">
            <v-file-input
              v-model="file"
              class="d-flex"
              show-size
              accept="image/*"
              @change="onFileInput"
              :rules="[() => !!file || 'This field is required']"
            >
              <template #label>
                <span class="red--text"><strong>* </strong></span>Your Poster
                File
              </template>
            </v-file-input>
          </v-col>
        </v-row>
        <v-col class="mx-auto" cols="12" sm="6">
          <!-- <span class="red--text"><strong>* </strong></span> -->
          <v-text-field
            required
            v-model="title"
            :rules="[() => !!title || 'This field is required']"
            counter="250"
            hint="What's the name of your Poster?"
            label="Title"
          ></v-text-field>
        </v-col>
        <v-col class="mx-auto" cols="12" sm="6">
          <v-text-field
            v-model="authors"
            :rules="rules"
            counter="250"
            hint="Separate author names by comma (e.g. John C., Mark B.)"
            label="Author(s)"
          ></v-text-field>
        </v-col>
        <v-row class="mt-8">
          <v-col class="mx-auto" cols="6">
            <Affiliations
              ref="affiliations"
              v-on:affiliations-changed="affiliations = $event"
            />
          </v-col>
        </v-row>

        <v-row class="mt-8">
          <v-col class="mx-auto" cols="6">
            <Tags ref="tags" v-on:tags-changed="tags = $event" />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mx-auto" cols="12" md="6">
            <v-textarea
              outlined
              v-model="description"
              label="Description"
              hint="Enter a short description of your Poster."
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mx-auto" cols="12" md="6">
            <!-- <img class="preview" :src="picture" /> -->
            <br />
            <v-btn
              :loading="uploadLoading"
              :disabled="uploadDisabled"
              x-large
              color="primary"
              type="submit"
              >Upload
              <v-icon class="pl-4" title="Views">mdi-upload</v-icon></v-btn
            >
            <p class="red--text mt-4" v-if="this.user == null">
              You must be "Signed In" to upload a poster.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-snackbar v-model="snackbarSuccess" :bottom="true" :color="'success'">
      Your poster was uploaded!
      <v-btn dark text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>

    <v-snackbar v-model="snackbarFailure" :bottom="true" :color="'success'">
      Your poster was uploaded!
      <v-btn dark text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import firebase from "firebase";
import Tags from "../components/Tags";
import Affiliations from "../components/Affiliations";
import { mapState } from "vuex";

export default {
  name: "Upload",
  components: { Tags, Affiliations },
  computed: {
    ...mapState(["user"]),
  },
  data() {
    return {
      snackbarSuccess: false,
      snackbarFailure: false,
      file: null,
      title: "",
      authors: "",
      description: "",
      tags: [],
      affiliations: [],
      valid: false,
      uploadLoading: false,
      uploadDisabled: true,
      picture: null,
      uploadValue: 0,
      downloadURL: null,
      rules: [(v) => v.length <= 250 || "Max 250 characters"],
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    file() {
      if (
        this.file == undefined ||
        this.file == null ||
        this.user == null ||
        this.title == ""
      ) {
        this.uploadDisabled = true;
      } else {
        this.uploadDisabled = false;
      }
    },
    user() {
      if (this.user == null || this.file == undefined || this.title == "") {
        this.uploadDisabled = true;
      } else {
        this.uploadDisabled = false;
      }
    },
    title() {
      if (this.title == "" || this.user == null || this.file == undefined) {
        this.uploadDisabled = true;
      } else {
        this.uploadDisabled = false;
      }
    },
  },
  methods: {
    onFileInput() {
      if (this.file != null) {
        this.upload = false;
      }
    },
    onUpload() {
      const storageRef = firebase.storage().ref();

      var metadata = {
        name: this.title,
      };

      let uploadTask = storageRef
        .child("posters/" + this.title)
        .put(this.file, metadata);

      // Register three observers:
      // 1. 'state_changed' observer, called any time the state changes
      // 2. Error observer, called on failure
      // 3. Completion observer, called on successful completion
      uploadTask.on(
        "state_changed",
        () => {
          this.uploadLoading = true;
        },
        (error) => {
          // Handle unsuccessful uploads
          console.log(error);
          this.snackbarFailure = true;
        },
        () => {
          // Handle successful uploads on complete
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log("File available at", downloadURL);
            this.downloadURL = downloadURL;
            this.snackbarSuccess = true;
            this.uploadLoading = false;
            // Take Storage url, and add to Firestore along with metadata
            this.$store
              .dispatch("addPoster", {
                user: this.user,
                downloadURL: this.downloadURL,
                title: this.title,
                authors: this.authors.split(","),
                affiliations: this.affiliations,
                tags: this.tags,
                description: this.description,
              })
              .then(
                () => {
                  this.file = null;
                  this.downloadURL = "";
                  this.title = "";
                  this.authors = "";
                  this.tags = [];
                  this.$refs.tags.clearValues();
                  this.affiliations = [];
                  this.$refs.affiliations.clearValues();
                  this.description = "";
                },
                (error) => {
                  console.log("failed to add Poster", error);
                }
              );
          });
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#upload {
  text-align: center;
}
</style>
